<template>
    <div>
        Redirect From quickBook
    </div>
</template>

<script>
import {getQuickBooksApi} from '@/api/quickBook'
export default {
  async created () {
     
    const payload = {
      code: this.$route.query.code,
      realmId: parseInt(this.$route.query.realmId)
    }
    try {
      const data = await getQuickBooksApi(payload)
      
    } catch (api_error) {
      
      this.showSuccessMessage('error', api_error.data.message, 'danger')
      // 
    }
    // const data = await 
  }
        
}
</script>

<style lang="scss" scoped>

</style>